module.exports = __webpack_public_path__ + "vue_assets/img/logo.5820abd4.png";